(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiMyTrainingFinancial', taiMyTrainingFinancial);

    Module.filter('licensesFlter', function() {
        //處理結果的格式化.
        return function(dataList, keyValue) {
            //==
            keyValue = keyValue || '';
            keyValue = (keyValue + '').toLowerCase();
            //==
            var result = [];
            var regExpCompare = new RegExp(keyValue, "g");
            _.forEach(dataList, function(perItem) {
                var compareString = perItem.name || '';
                if (compareString.toLowerCase().match(regExpCompare)) {
                    result.push(angular.copy(perItem));
                }
            });
            if (result.length < 1) {
                result.push({
                    name: '查無此證照名稱',
                    id: -1
                });
            }
            return result;
        };
    });

    function taiMyTrainingFinancial() {
        var directive = {
            bindToController: true,
            controller: taiMyTrainingFinancialController,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/taiMyTraining.financial.html',
            scope: {
                translatePool: '=',
                isFocus: '=',
                ssoInfo: '='
            }
        };
        return directive;
    }
    /* @ngInject */
    function taiMyTrainingFinancialController($uibModal, $scope, modalService, trainingInnerService,
        $rootScope, $q, finacialLicicense, $timeout) {
        var vm = this;
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        vm.translatePool = $scope.$parent.vm.data.translatePool;
        vm.ssoInfo = $scope.$parent.vm.data.ssoInfo;
        //===Main===
        onInit();
        //==========
        function onInit() {
            //console.log('onInit');
            vm.finacialLicicense = finacialLicicense;
            vm.submit = submit;
            vm.effectiveChange = effectiveChange;
            vm.openCertificateStatusSelector = openCertificateStatusSelector;
            vm.openCertificateTypeSelector = openCertificateTypeSelector;
            vm.openCourseListSelector = openCourseListSelector;
            vm.licenseKeyUp = licenseKeyUp;
            vm.certificateChange = certificateChange;
            vm.courseListSelectChange = courseListSelectChange;
            vm.getcourseList = getcourseList;
            vm.licenseBlur = licenseBlur;
            //vm.method = methodList(); //找機會要把上面的設定移到這裡
            //=======
            vm.financial = {};
            // console.log("taiMyTrainingFinancial onInit()");
            vm.isMobile = modalService.isMobile();
            //vm.isMobile=true;
            vm.menuNo = parseInt(getMenuQueryString());
            vm.data = dataInit();
            vm.view = viewInit();

            vm.UserInfo = vm.ssoInfo.cName + "(" + vm.ssoInfo.empId + ")";
            vm.UserDept = vm.ssoInfo.depName;
            vm.tabChange = tabChange;
            //console.log("82===>");


            $scope.$watch('vm.data.financialFilter.length', function(newValue, oldValue) {
                if (newValue === oldValue) { return; }
                if (!newValue) { newValue = 0; }
                vm.view.recordEmpty = newValue < 1;
                //console.log("89===>");
            });
            $scope.$watch('vm.data.authorizedHoursFilter.length', function(newValue, oldValue) {
                if (newValue === oldValue) { return; }
                if (!newValue) { newValue = 0; }
                vm.view.licienceEmpty = newValue < 1;
                //console.log("95===>");
            });
            $scope.$watch('vm.isFocus', function(newValue) {
                //console.log("98===>" + newValue);
                if (newValue === true) {
                    logicInit();
                }
            });
        }

        function dataInit() {
            //console.log('dataInit');
            var result = {
                //tabIndex: 0, //................選單序號
                financial: [], //..............證照紀錄API回傳清單
                financialFilter: [], //........證照紀錄於Filter處理後結果
                authorizedHours: [], //........證照認列時數API回傳清單
                authorizedHoursFilter: [], //..證照認列時數於Filter處理後結果
            };
            return result;
        }

        function viewInit() {
            //console.log('viewInit');
            var result = {
                recordEmpty: false, //..............證照紀錄資料為空
                licienceEmpty: false, //.............證照認列時數為空
                isInited_Page1: false, //............是否被初始化過(Page1)
                pageLoaded_Page1: false, //..........頁面讀取完畢(Page1)
                pageLoading_Page1: false, //.........頁面讀取中(Page1)
                isInited_Page2: false, //............是否被初始化過(Page2)
                pageLoaded_Page2: false, //..........頁面讀取完畢(Page2)
                pageLoading_Page2: false, //.........頁面讀取中(Page2)
                isInited_Page3: false, //............是否被初始化過(Page3)
                pageLoaded_Page3: false, //..........頁面讀取完畢(Page3)
                pageLoading_Page3: false, //.........頁面讀取中(Page3)
            };
            return result;
        }


        function logicInit() {
            // /* 漢堡選單click事件 */
            //console.log('logicInit ', vm.menuNo);

            if (vm.menuNo === -9991) {
                vm.data.tabIndex = 0;
            }
            if (vm.menuNo === -9992) {
                vm.data.tabIndex = 1;
            }
            if (vm.menuNo === -9993) {
                vm.data.tabIndex = 2;
            }


            switch (vm.data.tabIndex) {
                case 0:
                    return logicInit_Page1();
                case 1:
                    return logicInit_Page2();
                case 2:
                    return logicInit_Page3();
                default:
                    break;
            }
        }

        function logicInit_Page1() {
            //console.log('logicInit_Page1');
            // if (vm.view.isInited_Page1 === true) {
            //     return;
            // }
            vm.view.isInited_Page1 = true;
            vm.view.pageLoaded_Page1 = false;
            vm.view.pageLoading_Page1 = true;
            //========
            var promiseList = [
                trainingInnerService.getFinancial(-1), // 證書記錄(資料)
                trainingInnerService.getEffectives(), // 證照狀態
            ];
            return $q.all(promiseList)
                .then(function(receiveData) {
                    vm.data.financial = receiveData[0];
                    vm.data.effectives = receiveData[1];
                })
                .then(function() {
                    _.forEach(vm.data.financial, function(item) {
                        item.workflow = workflowFormat(item);
                    });

                    vm.view.recordEmpty = vm.data.financial.length < 1;
                    vm.effective = vm.data.effectives[0]; // 預設為全部
                })
                .then(function() {
                    //===
                    vm.view.pageLoaded_Page1 = true;
                    vm.view.pageLoading_Page1 = false;
                    //以menu來選定tab
                    $timeout(function() {
                        $scope.activeTabIndex = 0;
                    });
                });
        }

        function logicInit_Page2() {
            //console.log('logicInit_Page2');
            if (vm.view.isInited_Page2 === true) {
                return;
            }
            vm.view.isInited_Page2 = true;
            vm.view.pageLoaded_Page2 = false;
            vm.view.pageLoading_Page2 = true;
            //========
            var promiseList = [
                trainingInnerService.getCertificateType(), // 證照類別(下拉單)
            ];
            //console.log('promiseList :', promiseList);
            return $q.all(promiseList)
                .then(function(receiveData) {
                    vm.data.certificateType = receiveData[0];
                })
                .then(function() {
                    vm.certificate = vm.data.certificateType[0];
                    //console.log('init vm.certificate :', vm.certificate);
                    certificateChange();
                    //以menu來選定tab
                    $timeout(function() {
                        $scope.activeTabIndex = 1;
                    });
                    vm.view.pageLoaded_Page2 = true;
                    vm.view.pageLoading_Page2 = false;
                });
        }

        function logicInit_Page3() {
            //console.log('logicInit_Page3');
            // if (vm.view.isInited_Page3 === true) {
            //     return;
            // }
            vm.view.isInited_Page3 = true;
            vm.view.pageLoaded_Page3 = false;
            vm.view.pageLoading_Page3 = true;
            //========
            var promiseList = [
                trainingInnerService.getAuthorizedHours(), // 證書認列時數(資料)
            ];
            return $q.all(promiseList)
                .then(function(receiveData) {
                    vm.data.authorizedHours = receiveData[0];
                    //console.log(receiveData);
                })
                .then(function() {
                    //內訓課程類別名稱
                    var courseTypeInternal = vm.translatePool.tsunInternalCourse;
                    //外訓課程類別名稱
                    var courseTypeExternal = vm.translatePool.tsunExternalCourse;
                    _.forEach(vm.data.authorizedHours, function(item) {
                        //console.log(item);
                        //證照時數可修課程清單
                        // var regExFormat1 = /(\([^\(^\)]*\))/g;//.....去除括弧內資料
                        // var regExFormat2 = /([\d]*-?[\d]*)/g;//......去除開始時間設定
                        getcourseList(item).then(function(data) {
                            item.courseList = _.filter(data, function(courseItem) {
                                //外訓資料要回公司找經辦人員申請
                                return (courseItem.courseType !== 3);
                            });
                            //console.log('Init courseItem:', item.courseList);
                            item.courseListGroup = _.chain(item.courseList)
                                .groupBy("courseId")
                                .map(function(courseList) {
                                    _.forEach(courseList, function(courseItem, index) {
                                        courseItem.groupByIndex = (index + 1);
                                        courseItem.showName = courseItem.sessionName || '';
                                    });
                                }).value();
                            if (item.courseList.length < 1) {
                                item.courseList.unshift({
                                    //空的內訓資料，查無資料時補上
                                    courseId:-1,
                                    courseType: 1,
                                    showName: vm.translatePool.tsunEmptyCourse,
                                });
                            }
                            item.courseList.unshift({
                                //空的外訓資料，用來顯示台新罐頭文字
                                courseId:-3,
                                courseType: 3,
                                showName: vm.translatePool.tsunExternalCourseNotAllowForWeb,
                            });
                            // tsunEmptyCourse
                            _.forEach(item.courseList, function(courseItem) {
                                if (courseItem.courseType !== 3) {
                                    courseItem.groupName = courseTypeInternal;
                                    if (courseItem.fcAuthHours) {
                                        courseItem.showName = courseItem.showName || '';
                                        courseItem.showName = courseItem.showName + "(" + courseItem.fcAuthHours + "小時)";
                                    }

                                } else {
                                    courseItem.groupName = courseTypeExternal;
                                }
                            });
                        });
                    });
                })
                .then(function() {
                    //取代時數為空的資料
                    _.forEach(vm.data.authorizedHours, function(data) {
                        if (data.trainingEndDate.length < 1) {
                            data.trainingEndDate = data.trainingEndDate.replace('', '~');
                        }
                    });
                    //以menu來選定tab
                    $timeout(function() {
                        $scope.activeTabIndex = 2;
                    });
                    vm.view.licienceEmpty = vm.data.authorizedHours.length < 1;
                    vm.view.pageLoaded_Page3 = true;
                    vm.view.pageLoading_Page3 = false;
                });

        }

        function workflowFormat(financialItem) {
            //console.log('workflowFormat');
            // workflow 整理
            var result = '';
            var checkList = ['workflowItem', 'workflowReason'];
            if (!financialItem) { return ''; }
            _.forEach(checkList, function(propName) {
                if (!financialItem[propName]) {
                    financialItem[propName] = '';
                }
            });

            if (financialItem.workflowItem !== '') {
                result += format("<li><span>{0}</span></li>", financialItem.workflowItem);
            }
            if (financialItem.workflowReason !== '') {
                result += format("<li><span>{0}</span></li>", financialItem.workflowReason);
            }
            if (result.length > 0) {
                result = format("<ul>{0}</ul>", result);
            }
            return result;
        }

        function getcourseList(licensesItem) {
            console.log('getcourseList');
            return trainingInnerService.getAuthorizedHoursCourse(licensesItem, sessionStorage.getItem("userLang"));
        }

        function submit() {
            // console.log("vm.financial.getDay", vm.financial.getDay);
            // console.log('vm.form1.$valid:',vm.form1.$valid);
            if (vm.form1.$valid) {
                trainingInnerService.postFinancial(vm.financial)
                    .then(function(result) {
                        if (!result) { return; }
                        postFinancialSucess();
                        toastr.success(vm.translatePool.tsunSendSuccess);
                    });
            } else {
                toastr.warning(vm.translatePool.tsunFormMsgRequiredEmpty);
            }
        }

        function postFinancialSucess() {
            //console.log('postFinancialSucess');
            vm.form1.$submitted = false;
            vm.financial.licenses = null;
            vm.financial.licensesNO = null;
            vm.financial.getDay = '';
            vm.financial.otherMark = null;
        }
        // 證照狀態 change 事件
        function effectiveChange(result) {
            //console.log('effectiveChange');
            var status = result.id;
            //var status = vm.effective.id;
            trainingInnerService.getFinancial(status).then(function(data) {
                vm.data.financial = data;
                _.forEach(vm.data.financial, function(item) {
                    item.workflow = workflowFormat(item);
                });
            });
        }

        // 證照名稱欄位 key up 事件
        function licenseKeyUp() {
            // 因為找不到popup的display來源，所以手動show
            //console.log('licenseKeyUp');
            $('[uib-typeahead-popup].dropdown-menu').show();
        }

        // 證照類別 change 事件
        function certificateChange() {
            // console.log('certificateChange');
            // console.log("vm.certificate", vm.certificate);
            trainingInnerService.getLicensesNames(vm.certificate.id).then(function(data) {
                //console.log('certificateChange',data);
                vm.data.licensesNames = data;
            });
            vm.financial.licenses = [];
        }

        // 認列時數，可參與之課程清單 change 事件
        function courseListSelectChange(List, item) {
            //console.log('courseListSelectChange');
            // console.log('before change List:', List);
            // console.log('before change item:', item);
            if (!item) { return; }
            if (!item.sessionId) { return; }
            var modal = modalService.courseDetail(item, null, 2);
            modal.result.then(function(data) {
                if (data) { enrollSuccess(List, item); }
            });
            //console.log('after change:', item);
        }

        function enrollSuccess(List, item) {
            //console.log('enrollSuccess');
            var itemIndex = _.findIndex(List, { sessionId: item.sessionId });
            if (itemIndex > -1) {
                List.splice(itemIndex, 1);
            }
        }

        function tabChange(index) {
            //console.log('tabChange');
            if (vm.menuNo === -9991 || vm.menuNo === -9992 || vm.menuNo === -9993)
                return;
            vm.data.tabIndex = index;
            switch (vm.data.tabIndex) {
                case 0:
                    logicInit_Page1();
                    break;
                case 1:
                    logicInit_Page2();
                    break;
                case 2:
                    logicInit_Page3();
                    break;
                default:
                    break;
            }
        }

        function licenseBlur() {
            //console.log('licenseBlur');
            if ((typeof vm.financial.licenses).toLowerCase() !== 'object') {
                vm.financial.licenses = "";
            }
            if (!vm.financial.licenses.id) { return; }
            if (vm.financial.licenses.id < 1) {
                vm.financial.licenses = null;
            }
        }

        function openCertificateStatusSelector() {
            //console.log('openCertificateStatusSelector');
            var result = modalService.openOptionSelector(trainingInnerService.getEffectives(), 'tsunCertificateStatus',false);
            //這個則是接收傳回來的值
            result.result.then(function(result) {
                vm.effective = result;
                //console.log('result :', result);
                effectiveChange(result);
            });
        }

        function openCertificateTypeSelector() {
            //console.log('openCertificateTypeSelector');
            var result = modalService.openOptionSelector(trainingInnerService.getCertificateType(), 'tsunCretificateClass',false);
            //這個則是接收傳回來的值
            result.result.then(function(result) {
                vm.certificate = result;
                //console.log('result :', vm.certificate);
                certificateChange();
            });
        }

        function openCourseListSelector(item) {
            //console.log('openCourseListSelector',item);
            var result = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/courseListSelector.html',
                controller: 'courseListSelectorController as vm',
                size: 'sm',
                backdrop: 'static',
                taiClass: modalService.getTaiClass(),
                resolve: {
                    courseItem: function() {
                        return item;
                    },
                }
            });
            //這個則是接收傳回來的值
            result.result.then(function(result) {
                courseListSelectChange(result[0], result[1]);
            });
        }
    }
})();